import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
const guideRowHtml = (props) => {
  const innerClasses = [
    "row row--gap-16",
    props.cols ? `${EditorClasses.Grid} ${EditorClasses.Column}-${props.cols}` : ""
  ];
  return html`
    <div class="${EditorClasses.Row}">
      <div class="${innerClasses.join(" ").trim()}">
        <ssg-children/>
      </div>
    </div>
  `;
};
export {
  guideRowHtml
};
//# sourceMappingURL=component.js.map
